import * as S from './InfoLabel.styles';

interface InfoLabelProps {
  label: string;
  value: string;
}

export const InfoLabel = ({ label, value }: InfoLabelProps) => {
  return (
    <S.Wrapper data-test-id='InfoLabelWrapper'>
      <S.Label data-test-id='InfoLabelLabel'>{label}</S.Label>
      <S.Value data-test-id='InfoLabelValue'>{value}</S.Value>
      <S.Divider data-test-id='InfoLabelDivider' />
    </S.Wrapper>
  );
};

InfoLabel.displayName = 'InfoLabel';
